"use client";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import * as comp from "@getpara/react-components";
import { getOnRampNetworks } from "@getpara/web-sdk";
import styled from "styled-components";
import { getAssetCode, getAssetName, ON_RAMP_ASSETS } from "../../constants/constants.js";
import { useModalStore } from "../../stores/index.js";
import { useRef, useState } from "react";
import { useAddFunds } from "./AddFundsContext.js";
import { useActiveWallet } from "../../hooks/useActiveWallet.js";
import { AssetIcon } from "../common.js";
import { AnimatePresence, motion } from "framer-motion";
import { contentMotionProps } from "./common.js";
function AddFundsAsset() {
  const onRampConfig = useModalStore((state) => state.onRampConfig);
  const { assets, setAsset, network, setNetwork } = useAddFunds();
  const activeWallet = useActiveWallet();
  const [isAtBottom, setIsAtBottom] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);
  const [searchStr, setSearchStr] = useState("");
  const ref = useRef(null);
  const onSelect = (_asset) => __async(this, null, function* () {
    yield setAsset(_asset);
    if (!network) {
      yield setNetwork(
        getOnRampNetworks(onRampConfig.assetInfo, {
          walletType: activeWallet.type,
          assets: [_asset]
        })[0]
      );
    }
  });
  const onScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = ref.current;
    if (scrollTop + clientHeight >= scrollHeight - 30) {
      setIsAtBottom(true);
    } else {
      setIsAtBottom(false);
    }
    if (scrollTop < 30) {
      setIsAtTop(true);
    } else {
      setIsAtTop(false);
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(AnimatePresence, { mode: "sync", children: assets.length >= 4 && /* @__PURE__ */ jsx(motion.div, __spreadProps(__spreadValues({}, contentMotionProps), { children: /* @__PURE__ */ jsx(
      SearchInput,
      {
        placeholder: "Search for an asset",
        value: searchStr,
        onCpslInput: (e) => {
          setSearchStr(e.detail.value);
        },
        children: /* @__PURE__ */ jsx(comp.CpslIcon, { icon: "search", slot: "start" })
      }
    ) })) }),
    /* @__PURE__ */ jsx(ScrollContainer, { isAtBottom, isAtTop, ref, onScroll, children: /* @__PURE__ */ jsx(AssetList, { children: /* @__PURE__ */ jsx(AnimatePresence, { mode: "sync", children: assets.filter((asset) => {
      return searchStr === "" || getAssetCode(asset).toLowerCase().startsWith(searchStr.toLowerCase()) || getAssetName(asset).toLowerCase().startsWith(searchStr.toLowerCase());
    }).map((asset) => /* @__PURE__ */ jsx(
      motion.li,
      {
        style: { width: "100%" },
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.2 },
        children: /* @__PURE__ */ jsxs(AssetButton, { fullWidth: true, variant: "secondary", onClick: () => onSelect(asset), children: [
          /* @__PURE__ */ jsx(AssetIcon, { asset, size: "48px" }),
          /* @__PURE__ */ jsxs(Info, { children: [
            /* @__PURE__ */ jsx(Code, { variant: "bodyL", children: ON_RAMP_ASSETS[asset].code }),
            /* @__PURE__ */ jsx(Name, { variant: "bodyS", children: ON_RAMP_ASSETS[asset].name })
          ] })
        ] }, asset)
      },
      asset
    )) }) }) })
  ] });
}
const ScrollContainer = styled.div`
  height: calc(100% - 56px);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  mask-image: ${({ isAtBottom, isAtTop }) => !isAtBottom && !isAtTop ? "linear-gradient(to bottom, transparent 0%, black 24px, black calc(100% - 24px), transparent 100%)" : !isAtBottom ? "linear-gradient(to bottom, black calc(100% - 24px), transparent 100%)" : !isAtTop ? "linear-gradient(to top, black calc(100% - 24px), transparent 100%)" : "none"};
`;
const AssetList = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  list-style: none;
  padding-inline-start: 0;
  margin: 0;
  padding: 0px;
`;
const AssetButton = styled(comp.CpslButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  --button-secondary-background-color: var(--cpsl-color-background-8);
  --button-secondary-border-color: var(--cpsl-color-background-8);
  --button-secondary-hover-background-color: var(--cpsl-color-background-16);
  --button-secondary-hover-border-color: var(--cpsl-color-background-16);
`;
const Info = styled(comp.CpslCol)`
    text-align: left;
  `, Code = comp.CpslText, Name = comp.CpslText;
const SearchInput = styled(comp.CpslInput)`
  --container-background-color: var(--cpsl-color-background-8);
  --input-background-color: transparent;
`;
export {
  AddFundsAsset
};
